const common = {
  nav: {
    categories: "Catégories",
    guides: "Guides",
    shipping: "Expédition",
    qc: "CQ",
    reviews: "Avis",
    comparisons: "Comparaisons",
    safety: "Sécurité",
    contact: "Contact",
    about: "À propos",
    products: "Produits",
  },
  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  hero: {
    h1: "AllChinaBuy Spreadsheet — Découvrez des produits, trouvailles et ressources d'achat",
    subtitle: "Explorez les dernières ressources du tableur AllChinaBuy, les trouvailles de produits, les guides d'achat, les informations d'expédition, les conseils de CQ et les ressources fiables — organisées en un seul endroit.",
    primaryCta: "Explorer le Spreadsheet AllChinaBuy",
    secondaryCta: "Parcourir les guides d'achat",
    trustText: "Ressource indépendante • Guides multilingues • Contenu mis à jour",
    mainCta: "Visiter le site principal",
  },
  categories: {
    title: "Catégories de shopping",
    shoes: "Chaussures",
    hoodies: "Sweats à capuche/Pulls",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons/Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements/Caleçons",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
  whatIs: {
    h2: "Qu'est-ce que le AllChinaBuy Spreadsheet?",
    description: "Le AllChinaBuy Spreadsheet est un moyen pratique de découvrir des ressources de produits organisées, des liens de produits, des catégories et des informations d'achat. Au lieu de chercher sur plusieurs sources, utilisez notre hub de ressources pour explorer les produits liés à AllChinaBuy, les guides et les informations pratiques en un seul endroit.",
    cta: "Explorer le Spreadsheet",
  },
  resources: {
    h2: "Explorer les ressources AllChinaBuy populaires",
    spreadsheet: "AllChinaBuy Spreadsheet",
    finds: "AllChinaBuy Trouvailles",
    products: "AllChinaBuy Produits",
    shippingResource: "AllChinaBuy Expédition",
    qcResource: "AllChinaBuy CQ",
    warehouse: "AllChinaBuy Entrepôt",
    review: "AllChinaBuy Avis",
    coupon: "AllChinaBuy Coupon",
  },
  guides: {
    h2: "Guides d'achat AllChinaBuy",
    reviewGuide: "Avis AllChinaBuy",
    shippingCost: "Guide des coûts d'expédition",
    warehouseGuide: "Guide de l'entrepôt",
    qcGuide: "Guide de CQ",
    safetyGuide: "Guide de sécurité",
    couponGuide: "Guide des coupons",
  },
  latestFinds: {
    h2: "Dernières trouvailles AllChinaBuy",
    cta: "Explorer les trouvailles AllChinaBuy",
  },
  shipping: {
    h2: "AllChinaBuy Expédition, CQ & Informations entrepôt",
    description: "Comprenez les options d'expédition, les processus d'entrepôt et les considérations de contrôle qualité d'AllChinaBuy avant de passer votre commande. Nos guides couvrent les méthodes d'expédition, les coûts potentiels, le suivi et les conseils de gestion des risques.",
  },
  comparison: {
    h2: "Comparaisons AllChinaBuy",
    description: "Comparez AllChinaBuy avec d'autres agents d'achat populaires pour prendre une décision éclairée sur votre expérience d'achat.",
  },
  safety: {
    h2: "AllChinaBuy est-il légitime et sûr?",
    description: "Nous fournissons des conseils neutres et fondés sur des preuves sur la sécurité, la légitimité et les facteurs de risque d'AllChinaBuy. Notre guide de sécurité couvre la sécurité des paiements, la vérification des vendeurs et les conseils de protection des acheteurs.",
    cta: "Lire le guide de sécurité AllChinaBuy",
  },
  whyUs: {
    h2: "Pourquoi utiliser notre hub AllChinaBuy Spreadsheet?",
    organized: "Ressources organisées",
    organizedDesc: "Tous les liens de produits, catégories et guides en un seul endroit pratique.",
    discovery: "Découverte facile des produits",
    discoveryDesc: "Trouvez ce dont vous avez besoin rapidement sans chercher sur plusieurs sites.",
    practical: "Guides pratiques",
    practicalDesc: "Guides d'achat étape par étape, conseils d'expédition et conseils de CQ.",
    shippingInfo: "Informations d'expédition",
    shippingInfoDesc: "Comprenez les méthodes d'expédition, les coûts et les délais avant d'acheter.",
    multilingual: "Contenu multilingue",
    multilingualDesc: "Accédez aux guides en anglais, français, danois et allemand.",
    updated: "Mises à jour régulières",
    updatedDesc: "Notre contenu est régulièrement mis à jour pour refléter les dernières informations.",
  },
  bottomCta: {
    h2: "Commencez à explorer AllChinaBuy",
    primaryCta: "Explorer le Spreadsheet AllChinaBuy",
    secondaryCta: "Visiter le site principal",
    description: "Explorez le tableur AllChinaBuy complet, parcourez les trouvailles de produits organisées et accédez aux guides d'achat détaillés dans votre langue préférée.",
  },
  articles: {
    h2: "Articles AllChinaBuy Spreadsheet",
    readMore: "Lire l'article",
  },
  footer: {
    disclaimer: "Avertissement : Ceci est une ressource d'information indépendante et n'est pas le site officiel d'AllChinaBuy. AllChinaBuy est une marque déposée de ses propriétaires respectifs.",
    spreadsheet: "AllChinaBuy Spreadsheet",
    resources: "Ressources",
    categories: "Catégories",
    guides: "Guides",
    reviews: "Avis",
    shipping: "Expédition",
    warehouse: "Entrepôt",
    qc: "CQ",
    comparisons: "Comparaisons",
    safety: "Sécurité",
    about: "À propos",
    contact: "Contact",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    editorial: "Politique éditoriale",
    language: "Langue",
    copyright: "© 2026 AllChinaBuy Spreadsheet Hub. Tous droits réservés.",
  },
  common: {
    readMore: "Lire la suite",
    learnMore: "En savoir plus",
    explore: "Explorer",
    view: "Voir",
    updated: "Mis à jour",
  },
  allChinaBuy: {
    title: "AllChinaBuy Spreadsheet",
    buyNow: "Acheter maintenant",
  },

  products: {
    title: "Tous les produits",
    description: "Parcourez notre collection sélectionnée de produits AllChinaBuy. Cliquez sur n'importe quel article pour visiter la page du produit et acheter via kaspreadsheet.com.",
    disclaimer: "Ceci est une ressource indépendante. Les produits renvoient à kaspreadsheet.com pour l'achat.",
    filterAll: "Toutes les catégories",
    searchPlaceholder: "Rechercher des produits...",
    productCount: "{{count}} produit",
    productCount_plural: "{{count}} produits",
    noResults: "Aucun produit trouvé",
    noResultsDesc: "Essayez d'ajuster votre recherche ou votre filtre de catégorie",
    clearFilters: "Effacer les filtres",
    buyNow: "Acheter maintenant",
    buy: "Acheter",
    viewAll: "Voir tous les produits",
    moreProducts: "Vous cherchez plus de produits?",
    moreProductsDesc: "Visitez le site principal kaspreadsheet.com pour le catalogue complet avec des milliers d'autres produits.",
  },
  meta: {
    siteTitle: "AllChinaBuy Spreadsheet Hub — Trouvailles de produits et guides d'achat",
    description: "Votre hub de ressources indépendant pour les ressources de tableur AllChinaBuy, les trouvailles de produits, les guides d'achat, les informations d'expédition et les conseils de CQ. Explorez des catégories et des guides organisés en plusieurs langues.",
  },

  article: {
    home: "Accueil",
    lastUpdated: "Dernière mise à jour",
    disclaimer: "Avertissement",
    disclaimerText: "Ceci est une ressource d'information indépendante et n'est pas le site officiel d'AllChinaBuy. Toutes les informations fournies sont uniquement à des fins éducatives. Vérifiez toujours les détails directement auprès des vendeurs avant d'effectuer des achats.",
    faqTitle: "Questions fréquemment posées",
    readyToExplore: "Prêt à explorer ?",
    ctaDesc: "Visitez le site principal AllChinaBuy pour parcourir le catalogue complet de produits et commencer vos achats.",
    relatedArticles: "Articles connexes",
    backToHome: "Retour à l'accueil",
    ctaText: "Continuer vers le site principal",
  },
};

export default common;